function fixLanguageLinks(scope = document) {
  const { shop_url, root_url } = window.theme.routes;
  const { language } = window.theme;

  const normalizedRootPath =
    new URL(root_url, shop_url).pathname.replace(/\/$/, "") || "/";
  if (normalizedRootPath === "/") return;

  const langPrefix = normalizedRootPath;
  const links = scope.querySelectorAll("a[href]");

  for (const link of links) {
    const href = link.getAttribute("href");

    const isCustomerAuthentificationLink = href.includes(
      "/customer_authentication/redirect",
    );
    if (isCustomerAuthentificationLink) continue;

    // Absolute internal links missing the language prefix
    if (href.includes(shop_url) && !href.includes(`${shop_url}${langPrefix}`)) {
      link.setAttribute(
        "href",
        href.replace(shop_url, `${shop_url}${langPrefix}`),
      );
      continue;
    }

    // Relative links (e.g. /products/handle) missing the language prefix
    if (href.startsWith("/") && !href.startsWith(langPrefix)) {
      link.setAttribute("href", `${langPrefix}${href}`);
    }
  }
}

document.addEventListener("DOMContentLoaded", () => fixLanguageLinks());
